import React, { Dispatch } from 'react';
import { IDesignerProfile } from '@components/pages/DesignerProfile/graphql/designer-profile-query.graphql';
import { IDesignerBoard } from '@components/pages/DesignerProfile/graphql/designer-boards.graphql';
import StickyButtonFooter from '@components/pages/StyleQuiz/shared/components/StickyButtonFooter/StickyButtonFooter';
import Loader from '@components/shared/Loader/Loader';
import Profile from '../Designer/Profile/Profile';
import Boards from '../Boards/Boards';
import Info from '../Designer/Info/Info';
import Tabs, { TABS } from '../shared/Tabs/Tabs';
import ChooseDesignerCTA from '../Designer/CTA/ChooseDesignerCTA';
import Testimonials from '../Testimonials/Testimonials';

import styles from './MobileVersion.module.scss';
import useBookDesignerAndProceedToPurchase from '../../DesignerProfileAdmin/PreferButton/utils';

interface IMobileVersionProps {
  designer: IDesignerProfile;
  initialBoards: IDesignerBoard[];
  tab: TABS;
  setTab: Dispatch<any>;
}

const MobileVersion = ({
  designer, initialBoards, tab, setTab
}: IMobileVersionProps) => {
  const { testimonials } = designer;
  const tabs: TABS[] = ['portfolio', 'profile'];

  const {
    bookDesignerAndProceedToPurchase,
    isChangingDesigner
  } = useBookDesignerAndProceedToPurchase();

  const chooseDesigner = async () => {
    bookDesignerAndProceedToPurchase(designer);
  };

  if (testimonials?.length) tabs.push('reviews');

  return (
    <>
      {
        isChangingDesigner && (
          <div className={styles.LoadingLogo}>
            <Loader />
          </div>
        )
      }
      <div className={styles.Root} data-test="mobile-version">

        <Tabs tabs={tabs} selectedTab={tab} set={setTab} />

        <Profile designer={designer} />

        { renderContent(tab, initialBoards, designer) }

        <StickyButtonFooter>
          <ChooseDesignerCTA text={`work with ${designer.firstName}`} chooseDesigner={chooseDesigner} />
        </StickyButtonFooter>
      </div>
    </>
  );
};

function renderContent(
  tab: TABS,
  boards: IDesignerBoard[],
  designer: IDesignerProfile
): React.ReactNode {
  switch (tab) {
    case 'portfolio':
      return <Boards initialBoards={boards} designer={designer} />;
    case 'profile':
      return <Info designer={designer} />;
    case 'reviews':
      return <Testimonials testimonials={designer.testimonials} />;
    default:
      return <></>;
  }
}

export default MobileVersion;
